export enum WizardPageEnum {
    FileSelection,
    Confirmation,
    Importing,
    ImportSummary,
    Cancel,
    Finish
}

export interface WizardPage {
    component: React.ReactElement<any>;
}